import React, {useEffect} from 'react';
import {Card} from 'primereact/card';
import Default from '../../../../vendors/components/Layouts/Default';
import Container from '../../../../vendors/components/Container';
import Field from '../../../../vendors/components/Field';
import {InputText} from 'primereact/inputtext';
import CompletarCadastroController from '../controller/completar-cadastro.controller';
import {InputMask} from 'primereact/inputmask';
import AnttDropdown from '../../../../vendors/components/Dropdown';
import {RadioButton} from 'primereact/radiobutton';
import {Checkbox} from 'primereact/checkbox';
import AnttButton from '../../../../vendors/components/Button';
import classNames from 'classnames';

export default function CompletarCadastro() {

  const controller = new CompletarCadastroController();
  const model = controller.model;

  useEffect(() => {
    controller.init();
  }, []);
  const header = () => {
    return (
      <>
        <div style={{padding: '1rem'}}>
          <h3 style={{color: '#0072BC', fontWeight: '700'}}>Complete seu cadastro</h3>
          <label style={{paddingTop: '5px', fontWeight: '400', fontSize: '14px'}}>Anteção para os campos obrigatórios(*)</label>
        </div>
      </>
    )
  }
  return (
    <>
      <Default
        menuItems={[]}>
        <Card
          header={header}
        >
          <h3>Dados Contribuinte</h3>
          <Container style={{marginTop: '10px'}}>
            <Field col={6}>
              <Container>
                <Field label="CPF" col={12}>
                  <InputMask
                    mask="999.999.999-99"
                    value={controller.idData.sub}
                    disabled={true}/>
                </Field>
                <Field label="Nome Completo" col={12}>
                  <InputText
                    value={controller.idData.name}
                    disabled={true}/>
                </Field>
                <Field label="E-mail" col={12}>
                  <InputText
                    value={controller.idData.email}
                    disabled={true}/>
                </Field>
                <Field label="CNPJs" col={12}>
                  {
                    controller.empresaList.map((m: any, index: any) => <div style={{display: 'flex', width: '100%'}} key={index}>
                      <InputMask mask="99.999.999/9999-99"
                                 value={m.cnpj}
                                 style={{marginBottom: '10px', width: '100%'}} disabled={true}/>
                    </div>)
                  }
                  <label style={{fontSize: '10px'}}>Para adicionar pessoas Jurídicas, vincule os CNPJs a sua conta gov.br</label>
                </Field>
              </Container>
            </Field>
            <Field col={6}>
              <Container className="container-border-left">
                <Field label="UF"
                       valid={model.ufValid}
                       col={6}>
                  <AnttDropdown
                    optionLabel="nomeUF"
                    optionValue="codigo"
                    filterBy="nomeUF"
                    value={model.cdUf}
                    options={controller.ufList}
                    className={classNames({'p-invalid': !model.ufValid})}
                    onBlur={() => controller.validaCampo(model.cdUf, model.setUfValid)}
                    onChange={(e) => {
                      model.setCdUf(e.value);
                      controller.obterMunicipio(e.value);
                    }}
                  />
                </Field>
                <Field label="Munícipio"
                       valid={model.municipioValid}
                       col={6}>
                  <AnttDropdown
                    optionLabel="nomeMunicipio"
                    optionValue="codigo"
                    value={model.cdMunicipio}
                    filterBy="nomeMunicipio"
                    className={classNames({'p-invalid': !model.municipioValid})}
                    onBlur={() => controller.validaCampo(model.cdMunicipio, model.setMunicipioValid)}
                    disabled={!controller.municipioList || controller.municipioList.length <= 0}
                    options={controller.municipioList}
                    onChange={(e) => {
                      model.setCdMunicipio(e.value);
                    }}
                  />
                </Field>
                <Field label="Tipo de interessado"
                       valid={model.tipoInteressadoValid}
                       col={12}>
                  <AnttDropdown options={controller.tipoInteressadoList}
                                optionValue="codigo"
                                value={model.cdTipoInteressado}
                                className={classNames({'p-invalid': !model.tipoInteressadoValid})}
                                onBlur={() => controller.validaCampo(model.cdTipoInteressado, model.setTipoInteressadoValid)}
                                onChange={(e) => model.setCdTipoInteressado(e.value)}
                                optionLabel="descricao"
                  />
                </Field>
                <Field col={12}>
                  <h3>Notificações</h3>
                </Field>
                <Field col={12}>
                  <Card className="portal-card-radio" header={
                    <div style={{padding: '20px'}}>
                      Deseja receber informações sobre os eventos?
                    </div>
                  }>
                    <div style={{padding: '20px'}}>
                      <RadioButton value="S"
                                   onChange={(e) => model.setStNotificarNovaAudiencia(true)}
                                   checked={model.stNotificarNovaAudiencia}/>
                      <label className="mr-5 ml-1">Sim</label>
                      <RadioButton value="N"
                                   onChange={(e) => model.setStNotificarNovaAudiencia(false)}
                                   checked={!model.stNotificarNovaAudiencia}/>
                      <label className="mr-5 ml-1">Não</label>
                    </div>
                  </Card>
                </Field>
                <Field col={12}>
                  <Card className="portal-card-radio" header={
                    <div style={{padding: '20px'}}>
                      Áreas de interesse
                    </div>
                  }>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      padding: '20px'
                    }}>
                      {
                        controller.areaInteresseList.map((m: any, index: any) =>
                          <div style={{width: '50%', marginTop: '15px'}} key={'area-interesse' + index}>
                            <Checkbox value={m.codigo}
                                      checked={controller.isCheckAreaInteresse(m.codigo)}
                                      onChange={(e) => controller.checkAreaInteresse(e.value)}
                                      id={m.codigo}/>
                            <label htmlFor={m.codigo} className="ml-2 ">{m.descricao}</label>
                          </div>
                        )
                      }
                    </div>
                  </Card>
                </Field>
              </Container>
            </Field>
          </Container>
          <div className="flex justify-content-end">
            <AnttButton
              label="Voltar"
              className="p-button-secondary mr-2"
            />
            <AnttButton
              label="Salvar"
              onClick={() => controller.salvar()}
            />
          </div>
        </Card>
      </Default>
    </>
  );
}
